import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { DeleteConfrimationModal } from '../../../components/admin/DeleteConfirmationModal';
import { getAllSchools, deleteSchool } from '../../../api/schoolsApi';
import { getAllDistrictSchoolsByUserId } from '../../../api/schoolsApi';

export default function Schools() {
    const { siteUserId } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const { districtId } = useParams();

    const [loading, setLoading] = useState(true);
    const [schools, setSchools] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const defaultSchoolObj = { id: 0, title: '', label: 'School', Deleted: false };
    const [schoolToDelete, setSchoolToDelete] = useState(defaultSchoolObj);
    const [schoolsPermission, setSchoolsPermission] = useState([]);

    useEffect(() => {
        if (!loading) return;

        const fetchSchools = async () => {
            try {
                const response = await getAllSchools(districtId);
                if (response.data.success) {
                    setSchools(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching schools:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchSchools();
    }, [loading, districtId]);

    useEffect(() => {
        getAllDistrictSchoolsByUserId(districtId, siteUserId).then(res => {
            if (res.data?.success) {
                const schools = res.data.data;
                setSchoolsPermission(schools);
            }
        });
    }, [districtId]);

    const handleAddSchool = () => {
        navigate(`/admin/districts/edit/${districtId}/schools/create`);
    };

    const handleEditSchool = (schoolId) => {
        navigate(`/admin/districts/edit/${districtId}/schools/${schoolId}`);
    };

    const handleDeleteTrigger = (schoolId, title) => {
        setSchoolToDelete({ ...defaultSchoolObj, id: schoolId, title });
        setShowDeleteModal(true);
    };

    const handleDeleteSchool = async () => {
        try {
            await deleteSchool(districtId, schoolToDelete.id);
            setSchoolToDelete(defaultSchoolObj);
            setShowDeleteModal(false);
            setLoading(true);
        } catch (error) {
            console.error('Error deleting school:', error);
        }
    };

    return (
        <>
            <DeleteConfrimationModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                handleDeleteEvent={handleDeleteSchool}
                model={schoolToDelete}
            />

            <div className="admin-tab-content">
                <button className="admin-button" onClick={handleAddSchool}>
                    <span className="admin-button-text">Add School</span>
                    <span className="admin-button-icon material-symbols-rounded" aria-hidden="true">add</span>
                </button>

                <div className="admin-table-wrap">
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th className="admin-table-name-cell">Name</th>
                                <th className="admin-table-action-cell">&nbsp;</th>
                                <th className="admin-table-action-cell">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {schools.length > 0 ? (
                                // Decide what to show based on role
                                (schoolsPermission.some(sp => sp.roleName?.toLowerCase() === 'school admin')
                                    ? schools.filter(school =>
                                        schoolsPermission.some(sp => sp.baseId === school.baseId)
                                    )
                                    : schools
                                ).map((school, idx) => (
                                    <tr key={`school_${idx}`}>
                                        <td>{school?.name || 'Unnamed School'}</td>
                                        <td className="table-action-cell">
                                            <button
                                                className="admin-table-action"
                                                title="edit"
                                                onClick={() => handleEditSchool(school?.baseId)}
                                            >
                                                <span className="material-symbols-rounded">edit</span>
                                            </button>
                                        </td>
                                        <td className="table-action-cell">
                                            <button
                                                className="admin-table-action"
                                                title="delete"
                                                onClick={() => handleDeleteTrigger(school?.baseId, school?.name)}
                                            >
                                                <span className="material-symbols-rounded">delete</span>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="admin-table-name-cell">No active schools</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
